import type { ConditionDetailType, ConditionOptionsData } from '../../types/condition';
import getOptionsRowNodeId from './getOptionsRowNodeId';

const isConditionCustomizeUpdated = (customize: (ConditionOptionsData | ConditionDetailType)[] | undefined, customizeOrg: ConditionDetailType[] | undefined): boolean => {
  if (customize !== undefined && customizeOrg !== undefined) {
    // 要素数が違っていたら差分あり
    const hasDiffAtNumber: boolean = customize.length !== customizeOrg.length;
    if (hasDiffAtNumber) {
      return true;
      // 要素数が同じだったときはまずConditionCustomizeにConditionOptionsData（例えばidを持たない）があるか調べ、
      // もしそれがあればconditionOrgのdetailCustomizeにそれと同じ組み合わせのデータが無ければ差分あり
    } else {
      // idを持たないデータを探す
      const conditionOptionsData: ConditionOptionsData | undefined = customize.find((data) => {
        // @ts-ignore
        return data.id === undefined;
      });
      // console.log(conditionOptionsData);
      if (conditionOptionsData !== undefined) {
        // そのデータと同じ組み合わせのデータがあるか探す
        const rowNodeId: string = getOptionsRowNodeId(conditionOptionsData);
        const sameDetailCustomize: ConditionDetailType | undefined = customizeOrg.find((detail) => {
          if (rowNodeId === getOptionsRowNodeId(detail)) {
            return true;
          } else {
            return false;
          }
        });
        return sameDetailCustomize === undefined;
      } else {
        return false;
      }
    }
  } else {
    return false;
  }
};

export default isConditionCustomizeUpdated;
